var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineGapers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 3,
    viewBox: "0 0 89 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.951172,
    width: 60.0338,
    height: 2.91217,
    fill: "#C32A7C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 64.9219,
    width: 12.302,
    height: 2.91217,
    fill: "#C32A7C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 81.1602,
    width: 6.88913,
    height: 2.91217,
    fill: "#C32A7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineGapers);
export default __webpack_public_path__ + "static/media/line_gapers.691474fb2f797753db4c78fe5c8abef6.svg";
export { ForwardRef as ReactComponent };